// @flow

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import map from './components/Map/MapReducers';
import type { MapReducersType } from './components/Map/MapReducers';

import { screenSaverReducers as screenSaver } from './components/ScreenSaver';
import type { ScreenSaverReducersType } from './components/ScreenSaver';

type AppStateType = {|
    routing: Object,
    map: MapReducersType,
    screenSaver: ScreenSaverReducersType
|};

const appState: AppStateType = {
    routing: routerReducer,
    map,
    screenSaver
};

export default combineReducers(appState);



// WEBPACK FOOTER //
// ./src/rootReducer.js